export default __webpack_public_path__ + "static/media/logo.e5ec651b.svg";